/**
 * EventTypeSelector - Event type selection cards
 * Extracted from EventsTab.jsx
 */
import { EVENT_TYPES } from './constants';

export const EventTypeSelector = ({ formData, setFormData }) => (
  <div>
    <label className="block text-xs text-zinc-500 uppercase mb-2">Event Type *</label>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {EVENT_TYPES.map(type => (
        <button
          key={type.value}
          type="button"
          onClick={() => setFormData({...formData, event_type: type.value})}
          className={`p-4 border text-left transition-all ${
            formData.event_type === type.value 
              ? 'border-orange-500 bg-orange-500/10' 
              : 'border-white/10 bg-zinc-800/50 hover:border-white/30'
          }`}
        >
          <span className={`font-secondary text-sm font-bold uppercase ${
            formData.event_type === type.value ? 'text-orange-500' : 'text-white'
          }`}>
            {type.label}
          </span>
          <p className="text-xs text-zinc-500 mt-1">{type.description}</p>
        </button>
      ))}
    </div>
  </div>
);

export default EventTypeSelector;
